import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { RandomGeneratorService } from './random-generator.service';

/**
 *  // In App Component einfügen
 *  const  version = require('../assets/version.json');
 *
 *  this.myVersionCheckService.init(version).subscribe(() => {
 *      // Hier kann zuvor auch ein Popup angezeigt werden
 *      location.reload(true);
 *  });
 *
 *  // Task zu gulpfile.js hinzufügen
 *  gulp.task('build:create-version', function() {
 *      var pkg = require('./package.json');
 *      var fs = require('fs');
 *      const d = new Date();
 *      fs.writeFile('src/assets/version.json', '{ "version": "' + pkg.version + '" , "timestamp": "' + d.toISOString() + '" }', () => {});
 *      return null;
 *  });
 *
 *  // Prebuild Schritt in package.json unter scripts hinzufügen
 *  "prebuild":"gulp build:create-version",
 *
 */
@Injectable({
    providedIn: 'root',
})
export class VersionCheckService {

    private versionChange: Subject<void> = new Subject<void>();
    private version: { version: string, timestamp: string };
    private interval: any;

    constructor(private myHttpClient: HttpClient,
                private myRandomGeneratorService: RandomGeneratorService,
    ) {
    }

    public observeVersionChange(version: { version: string, timestamp: string }, interval: number = 60000): Observable<void> {
        this.version = version;
        this.checkVersion(interval);
        return this.versionChange.asObservable();
    }

    /**
     *
     *  // This method will not work local
     *
     * */
    public reloadLocation(): void {
        if (location.hostname === 'localhost') {
            location.reload();
        } else {
            const form: HTMLFormElement = document.createElement('form');
            form.method = 'POST';
            form.action = location.href;
            document.body.appendChild(form);
            form.submit();
        }
    }

    private checkVersion(interval: number): void {
        if (this.interval) {
            clearInterval(this.interval);
        }
        this.interval = setInterval(async () => {
            const path: string = `assets/version.json?v=${this.myRandomGeneratorService.generateAlphaNumberId(10)}`;
            const actualVersion: { version: string, timestamp: string } = await this.myHttpClient
                .get(path)
                .toPromise().catch(() => null);
            if (actualVersion && this.version) {
                if (actualVersion.version !== this.version.version || actualVersion.timestamp > this.version.timestamp) {
                    console.warn('VersionCheckService change detected !');
                    console.warn(`VersionCheckService version - current ${actualVersion.version} new version ${this.version.version}`);
                    console.warn(`VersionCheckService timestamp - current ${actualVersion.version} new version ${this.version.version}`);
                    this.versionChange.next();
                }
            }
        }, interval);

    }
}
